import { CheckboxGroup as BaseCheckboxGroup } from '@base-ui/react/checkbox-group'
import React from 'react'

export interface CheckboxGroupProps {
  // The ticked items' `value`s. Omit it (and use `defaultValue`) for an
  // uncontrolled group.
  value?: string[]
  defaultValue?: string[]
  onValueChange?: (value: string[]) => void
  disabled?: boolean
  // Lands on the group element, so `styled(CheckboxGroup)` can lay it out.
  className?: string
  'aria-label'?: string
  // `<Checkbox value="x">label</Checkbox>` items.
  children?: React.ReactNode
}

export const CheckboxGroup = ({
  value,
  defaultValue,
  onValueChange,
  disabled,
  className,
  'aria-label': ariaLabel,
  children,
}: CheckboxGroupProps): React.ReactElement => (
  <BaseCheckboxGroup
    value={value}
    defaultValue={defaultValue}
    onValueChange={(next) => onValueChange?.(next)}
    disabled={disabled}
    className={className}
    aria-label={ariaLabel}
  >
    {children}
  </BaseCheckboxGroup>
)

CheckboxGroup.displayName = 'CheckboxGroup'
